// Supplies the batch site_summary for KPI tiles via per-key merge of each
// arriving telemetry:batch (djin-cloud#372 contract).
// The live per-second playback path is handled by useSiteSummaryPlayback (F1).

import { useEffect, useState } from 'react';
import { socketService } from '../services/socket';

interface TelemetryBatchData {
  site_id: string;
  site_summary?: Record<string, unknown>;
}

export function useDelayedSiteSummary(siteId: string | undefined): Record<string, unknown> {
  const [displayed, setDisplayed] = useState<Record<string, unknown>>({});

  useEffect(() => {
    setDisplayed({});

    const socket = socketService.getSocket();
    if (!socket || !siteId) return;

    const handler = (data: unknown) => {
      if (!data || typeof data !== 'object') return;
      const batch = data as TelemetryBatchData;
      if (batch.site_id !== siteId) return;

      if (batch.site_summary) {
        setDisplayed((prev) => ({ ...prev, ...batch.site_summary }));
      }
    };

    socket.on('telemetry:batch', handler);
    return () => {
      socket.off('telemetry:batch', handler);
    };
  }, [siteId]);

  return displayed;
}
